// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"142":"6466207a7dde96aeac09","407":"715af73938305ba17b06","508":"efc14e233abab4636aed","788":"f84101a1ad38dad0c232"}[chunkId] + ".css";
};